const PUB = typeof window !== "undefined" && window.location.pathname.startsWith("/kerala") ? "/kerala" : "";
export const asset = (path) => `${PUB}${path}`;

export const SITE = {
    name: "Morningstar Enterprises",
    legalName: "Morning Star Enterprises",
    domain: "https://www.morningstarworld.com/kerala",
    phoneDisplay: "+91 94471 77779",
    phoneTel: "tel:+919447177779",
    whatsapp: "https://wa.me/919447177779",
    whatsappFor: (product) =>
        `https://wa.me/919447177779?text=${encodeURIComponent(
            `Hi Morningstar Enterprises, I'd like technical and commercial details about ${product}.`,
        )}`,
    emails: ["sales@morningstarworld.com", "sunny@morningstarworld.com"],
    address:
        "Morningstar Enterprises, Vylassery Road, Palarivattom, Kochi - 682025, Kerala, India",
    addressShort: "Vylassery Road, Palarivattom, Kochi - 682025",
    regions: "Kerala · Tamil Nadu · Karnataka",
    established: "2009",
    youtube: "https://www.youtube.com/@morningstarenterprises",
    logo: asset("/mse-logo.png"),
};

export const KERALA_AREAS = [
    "Kochi", "Palarivattom", "Edappally", "Kakkanad", "Vyttila", "Tripunithura", "Fort Kochi",
    "Aluva", "Angamaly", "Perumbavoor", "Muvattupuzha", "Piravom", "Ernakulam",
    "Thrissur", "Guruvayur", "Chalakudy", "Irinjalakuda", "Kodungallur",
    "Kozhikode (Calicut)", "Vadakara", "Thiruvananthapuram", "Attingal", "Nedumangad", "Neyyattinkara",
    "Kollam", "Punalur", "Pathanamthitta", "Thiruvalla", "Changanassery", "Chengannur",
    "Alappuzha", "Kayamkulam", "Haripad", "Kottayam", "Idukki", "Thodupuzha", "Adimali", "Munnar",
    "Palakkad", "Ottapalam", "Pattambi", "Malappuram", "Manjeri", "Tirur", "Perinthalmanna", "Ponnani",
    "Wayanad", "Kalpetta", "Sultan Bathery", "Kannur", "Thaliparamba", "Payyanur", "Kasaragod", "Kanhangad",
];

export const OTHER_STATE_AREAS = [
    "Chennai", "Coimbatore", "Madurai", "Trichy", "Salem",
    "Bengaluru", "Mysuru", "Mangaluru", "Hubballi",
];

export const SISTER_CONCERNS = [
    {
        name: "InstarLED",
        location: "Idukki",
        desc: "LED lighting solutions",
        url: null,
    },
    {
        name: "Absolute Technosolutions",
        location: "Piravom",
        desc: "Technology solutions & services",
        url: null,
    },
    {
        name: "Auracrest Haven Resorts",
        location: "Munnar",
        desc: "A-frame cottage resort in the Munnar hills",
        url: "https://www.auracresthaven.com",
    },
    {
        name: "Morning Star Metro Home Stay",
        location: "Kochi",
        desc: "Home stay accommodation in Kochi",
        url: "https://www.auracresthaven.com/morning_star_metro_home_stay_kochi/",
    },
    {
        name: "Spyzzie Food Delivery App",
        location: "Munnar Region",
        desc: "Food delivery app serving Munnar, Anachal & 20+ areas",
        url: "https://www.spyzzie.in",
    },
];

export const IMG = {
    logo: SITE.logo,
    outdoorLed:
        "https://www.morningstarworld.com/wp-content/uploads/2024/07/cropped-pexels-photo-1058275-1058275-1024x512.jpg",
    indoorLed:
        "https://www.morningstarworld.com/wp-content/uploads/2024/07/website_indoor.png",
    ifpd: "https://www.morningstarworld.com/wp-content/uploads/2024/07/wisdomatic_ifpd_website-1024x576.png",
    schoolBoard:
        "https://www.morningstarworld.com/wp-content/uploads/2024/07/ncs.png",
    ledWallBig:
        "https://www.morningstarworld.com/wp-content/uploads/2024/07/pexels-photo-1058275-1058275-1024x682.jpg",
    scrollingRed:
        "https://images.pexels.com/photos/7740339/pexels-photo-7740339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    scrollingWarning:
        "https://images.pexels.com/photos/9504092/pexels-photo-9504092.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    classroom:
        "https://images.unsplash.com/photo-1627546922331-2e37685db947?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxpbnRlcmFjdGl2ZSUyMGZsYXQlMjBwYW5lbCUyMGRpc3BsYXklMjBjbGFzc3Jvb20lMjBzbWFydCUyMGJvYXJkJTIwZGlnaXRhbCUyMHNjcmVlbnxlbnwwfHx8fDE3OTI2Mzc0ODZ8MA&ixlib=rb-4.1.0&q=85",
    conferenceWall:
        "https://images.unsplash.com/photo-1758691736483-5f600b509962?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHx2aWRlbyUyMHdhbGwlMjBjb25mZXJlbmNlJTIwcm9vbSUyMGRpZ2l0YWwlMjBzaWduYWdlJTIwcG9kaXVtJTIwcHJlc2VudGF0aW9ufGVufDB8fHx8MTc5MjYzNzQ5NXww&ixlib=rb-4.1.0&q=85",
    podium:
        "https://images.pexels.com/photos/6949938/pexels-photo-6949938.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    vcRoom:
        "https://images.unsplash.com/photo-1676275774895-7fbba85dce94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHx2aWRlbyUyMHdhbGwlMjBjb25mZXJlbmNlJTIwcm9vbSUyMGRpZ2l0YWwlMjBzaWduYWdlJTIwcG9kaXVtJTIwcHJlc2VudGF0aW9ufGVufDB8fHx8MTc5MjYzNzQ5NXww&ixlib=rb-4.1.0&q=85",
    ifpdShot1:
        "https://www.morningstarworld.com/wp-content/uploads/2024/06/photo_2024-06-29_17-47-00-1024x768.jpg",
    ifpdShot2:
        "https://www.morningstarworld.com/wp-content/uploads/2024/06/photo_2024-06-30_11-37-40-1024x576.jpg",
    ifpdShot3:
        "https://www.morningstarworld.com/wp-content/uploads/2024/06/photo_2024-06-30_11-36-47-1024x576.jpg",
    ifpdShot4:
        "https://www.morningstarworld.com/wp-content/uploads/2024/06/photo_2024-06-29_17-47-31-1024x768.jpg",
};
